/**
 * Централизованная конфигурация приложения
 */

// URLs
export const POCKETBASE_URL = import.meta.env.VITE_POCKETBASE_URL || 'http://127.0.0.1:8090';
export const API_URL = import.meta.env.VITE_API_URL || '';

// Environment
export const isDev = import.meta.env.DEV;
export const isProd = import.meta.env.PROD;

// Subscription limits (free tier)
export const FREE_TIER_LIMITS = {
  projects: 1,
  personas: 1,
  analyses: 1,
  positioning: 0,
  businessModel: 0,
  mvpPlans: 0,
  financialModel: 0,
  researchMessages: 0,
  mentorMessages: 10,
} as const;

// Subscription prices (RUB) — one-time payment
export const SUBSCRIPTION_PRICES = {
  basic: 990,
  full: 1490,
  // Legacy
  creator: 599,
  top_creator: 1490,
} as const;
